import React from "react";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { TooltipCustom } from "@services/ui-components";

interface StartTutorialButtonProps {
    handleClick: () => void;
    classBtn?: string;
    iconOnly?: boolean;
    squareSize?: number;
    tooltipResetKey?: number;
}

const StartTutorialButton: React.FC<StartTutorialButtonProps> = ({
    handleClick,
    classBtn = "w-100",
    iconOnly = false,
    squareSize = 45,
    tooltipResetKey,
}) => {
    const { t } = useTranslation();

    if (iconOnly) {
        const btn = (
            <Button
                variant="outline-primary"
                onClick={handleClick}
                className={`d-inline-flex align-items-center justify-content-center p-0 ${classBtn}`}
                style={{ width: `${squareSize}px`, height: `${squareSize}px`, minWidth: `${squareSize}px` }}
            >
                <i className="bi bi-question-circle fs-16" />
            </Button>
        );

        return (
            <TooltipCustom
                overlayTooltipKey={tooltipResetKey}
                placement="bottom"
                text={t("How to connect Online Booking?")}
            >
                {btn}
            </TooltipCustom>
        );
    }

    return (
        <Button variant="outline-primary" className={`text-nowrap ${classBtn}`} onClick={handleClick}>
            {t("How to connect Online Booking?")}
        </Button>
    );
};

export default StartTutorialButton;
